import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { UserServiceIdentity } from '../services/user.service';
import { DealershipService } from '../services/dealership.service';
import { CustomerServiceIdentity } from '../services/customer.service';
import { JobsiteService } from '../services/jobsite.service';
import { PendingUserOverview, UserOverview, UserAccessType, UserRequestModel } from '../models/user.model';
import { DealerGroupV, DealershipOverview } from '../models/dealership.model';
import { CustomerOverview } from '../models/customer.model';
import { JobsiteOverview } from '../models/jobsite.model';
import { MatDialog } from '@angular/material/dialog'; import { AddUserModalComponent } from '../add-user-modal/add-user-modal.component';
import { EditUserModalComponent } from '../edit-user-modal/edit-user-modal.component';
import { AddCustomerModalComponent } from '../add-customer-modal/add-customer-modal.component';
import { AddJobsiteModalComponent } from '../add-jobsite-modal/add-jobsite-modal.component';
import { AddDealershipModalComponent } from '../add-dealership-modal/add-dealership-modal.component';
import { EditCustomerModalComponent } from '../edit-customer-modal/edit-customer-modal.component';
import { EditJobsiteModalComponent } from '../edit-jobsite-modal/edit-jobsite-modal.component';
import { EditDealershipModalComponent } from '../edit-dealership-modal/edit-dealership-modal.component';
import { AddDealershipBrandingModalComponent } from '../add-dealership-branding-modal/add-dealership-branding-modal.component';
import { EditDealershipBrandingModalComponent } from '../edit-dealership-branding-modal/edit-dealership-branding-modal.component';
import { NotificationsService } from 'angular2-notifications';
import { AssignmentType } from '../models/access.model';
import { AssignModalComponent } from '../assign-modal/assign-modal.component';
import { SafeHtml } from '@angular/platform-browser';
import { AddDealergroupModalComponent } from '../add-dealergroup-modal/add-dealergroup-modal.component';
import { PageEvent } from '@angular/material/paginator';
import { ResetPasswordDialogComponent } from '../../../shared/components/reset-password-dialog/reset-password-dialog.component';

@Component({
  selector: 'administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit {

  loadingData = true;
  showPending = false;
  userTableData: UserOverview[];
  pendingUserTableData: PendingUserOverview[];
  filterUserTableText: string = '';
  userTableLoadingComplete = false;
  _currentUserJobRoles: string[] = [];
  dealershipTableData: DealershipOverview[];
  dealerGroupTableData: DealerGroupV[];
  filterDealerGroupTableText = '';
  customerTableData: CustomerOverview[];
  filterCustomerTableText = '';
  customerTableLoadingComplete = false;

  jobsiteTableData: JobsiteOverview[];
  filterJobsiteTableText = '';
  jobsiteTableLoadingComplete = false;
  filterDealershipTableText = '';
  dealershipTableLoadingComplete = false;
  userAccessType: UserAccessType;
  // addUserVisible = false;
  addUserVisible = true;  // Ensure that this value is properly set
  defaultTabIndex = 0; addCustomerVisible = false;
  addJobsiteVisible = false;
  addDealershipVisible = false;
  addDealerGroupVisible = false;
  dealershipsTabVisible = false;
  customersTabVisible = false;
  showCustomerNotes = false;
  undercarriageUrl: string;
  loading: boolean = false;

  loadSize: number = 100;
  loadingPage: number = 1;

  // MatPaginator Inputs
  length = 100;
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  recordCount: number = 0
  customerRecordCount: number = 0
  jobsiteRecordCount: number = 0
  dealerRecordCount: number = 0
  userRequestModel: UserRequestModel = new UserRequestModel();
  customerRequestModel: UserRequestModel = new UserRequestModel();
  jobsiteRequestModel: UserRequestModel = new UserRequestModel();
  dealerRequestModel: UserRequestModel = new UserRequestModel();
  // MatPaginator Output
  pageEvent: PageEvent;
    hasMenuAccess: boolean = false;

  constructor(private _appService: AppService, private _userService: UserServiceIdentity, private _dealershipService: DealershipService,
    private _customerService: CustomerServiceIdentity, private _jobsiteService: JobsiteService, public dialog: MatDialog,
    private _notification: NotificationsService,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Team Administration');
    this._appService.setPageSubTitle(
      `A team can be considered either a customer or a dealership.
          Each team consists of it\'s own group of users who have access to equipment within that team. `);
    this._userService.getUserAccessType().subscribe(response => {
      this.userAccessType = response;
      this._userService.getUserJobRoles().subscribe(response => {
        this._currentUserJobRoles.push(...response);
        this.setVisibleComponentsForUser();
      });
      this.loadingData = false;
    });


    this._appService.getUndercarriageUrl().subscribe(result => {
      if (result != null && result !== '') {
        this.showCustomerNotes = true;
        this.undercarriageUrl = result;
      }
    });

    this._currentUserJobRoles = [];
    this.reloadUsers(this.userRequestModel);
    this.reloadCustomers(this.customerRequestModel);
    this.reloadJobsites(this.jobsiteRequestModel);
    this.reloadDealerships(this.dealerRequestModel);
      this.reloadDealerGroups();
      this.checkMenuAccess();
  }

  filterUserText(event: any) {
    if (event.target.value.length == 0) { this.resetFieldsUserText(); }
    else if (event.target.value.length > 2) {
      this.userRequestModel.UserName = event.target.value;
      this.reloadUsers(this.userRequestModel);
    }
  }
  resetFieldsUserText() {
    this.filterUserTableText = "";
    this.userRequestModel.UserName = ""
    this.userRequestModel.pageIndex = 0;
    this.userRequestModel.pageSize = 50;
    this.reloadUsers(this.userRequestModel);
  }

  onUserPaginateChange(event: PageEvent) {
    //debugger;
    console.log(event);
    // this.reloadUsers(event.pageIndex + 1, event.pageSize);
    // this.reloadUsers(event.pageIndex + 1, event.pageSize);
    this.userRequestModel.pageIndex = event.pageIndex;
    this.userRequestModel.pageSize = event.pageSize;
    this.reloadUsers(this.userRequestModel);
  }

  reloadUsers(userRequestModel: any) {
    this.userTableLoadingComplete = false;
    this.loading = true
    this._userService.getAllUsers(userRequestModel).subscribe(response => {
      this.userTableData = response;
      //AES256
      //this.userTableData.forEach((user: any) => {
      //  user.FullName = this.crypto.decrypt(user.FullName);
      //  user.UserName = this.crypto.decrypt(user.UserName);
      //  user.Email = this.crypto.decrypt(user.Email);
      //});
      this.userTableLoadingComplete = true;
      this.loading = false;
      this.recordCount = this.userTableData[0].RecordCount
      //console.log("userTableData", this.userTableData);
      this.getPendingUsers(userRequestModel)
    });

  }

  getPendingUsers(userRequestModel: any) {
    this._userService.getPendingUsers(userRequestModel).subscribe(response => {
      this.pendingUserTableData = response;
      this.loading = false;
      console.log(this.pendingUserTableData);
    });

  }

  // Customer section //
  filterCustomerText(event: any) {
    if (event.target.value.length == 0) { this.resetFieldsCusomerText(); }
    else if (event.target.value.length > 2) {
      this.customerRequestModel.UserName = event.target.value;
      this.reloadCustomers(this.customerRequestModel);
    }
  }
  resetFieldsCusomerText() {
    this.filterCustomerTableText = "";
    this.customerRequestModel.UserName = ""
    this.customerRequestModel.pageIndex = 0;
    this.customerRequestModel.pageSize = 50;
    this.reloadCustomers(this.customerRequestModel);
  }


  onCustomerPaginateChangeCustomer(event: PageEvent) {
    debugger;
    console.log(event);
    // this.reloadUsers(event.pageIndex + 1, event.pageSize);
    // this.reloadUsers(event.pageIndex + 1, event.pageSize);
    this.customerRequestModel.pageIndex = event.pageIndex;
    this.customerRequestModel.pageSize = event.pageSize;
    this.reloadCustomers(this.customerRequestModel);
  }


  reloadCustomers(customerRequestModel: any) {

    this.customerTableLoadingComplete = false;
    this._customerService.getAllCustomersForAdminstration(customerRequestModel).subscribe(response => {
      this.customerTableData = response;
      this.customerTableLoadingComplete = true;
      this.customerRecordCount = this.customerTableData[0].RecordCount

    });
  }

  // Customer section end //

  // ///////////////////////////// Load jobsite////////////////////////////////////////////////
  filterJobsiteText(event: any) {
    if (event.target.value.length == 0) { this.resetFieldsJobsiteext(); }
    else if (event.target.value.length > 2) {
      this.jobsiteRequestModel.UserName = event.target.value;
      this.reloadJobsites(this.jobsiteRequestModel);
    }
  }
  resetFieldsJobsiteext() {
    this.filterJobsiteTableText = "";
    this.jobsiteRequestModel.UserName = ""
    this.jobsiteRequestModel.pageIndex = 0;
    this.jobsiteRequestModel.pageSize = 50;
    this.reloadJobsites(this.jobsiteRequestModel);
  }


  onJobsitePaginateChange(event: PageEvent) {
    this.jobsiteRequestModel.pageIndex = event.pageIndex;
    this.jobsiteRequestModel.pageSize = event.pageSize;
    this.reloadJobsites(this.jobsiteRequestModel);
  }

  reloadJobsites(jobsiteRequestModel: any) {
    this.jobsiteTableLoadingComplete = false;
    this._jobsiteService.getAllJobsitesForAdmin(jobsiteRequestModel).subscribe(response => {
      this.jobsiteTableData = response;
      this.jobsiteTableLoadingComplete = true;
      this.jobsiteRecordCount = response[0].RecordCount
      this.loading = false;
    });
  }
  // ///////////////////////////// Load jobsite////////////////////////////////////////////////


  // ///////////////////////////// Dealer ship start////////////////////////////////////////////////

  filterDealerShipText(event: any) {
    if (event.target.value.length == 0) { this.resetDealerShiptext(); }
    else if (event.target.value.length > 2) {
      this.dealerRequestModel.UserName = event.target.value;
      this.reloadDealerships(this.dealerRequestModel);
    }

  }
  resetDealerShiptext() {
    this.filterDealershipTableText = "";
    this.dealerRequestModel.UserName = ""
    this.dealerRequestModel.pageIndex = 0;
    this.dealerRequestModel.pageSize = 50;
    this.reloadDealerships(this.dealerRequestModel);
  }


  onDealerShipPaginateChange(event: PageEvent) {
    this.dealerRequestModel.pageIndex = event.pageIndex;
    this.dealerRequestModel.pageSize = event.pageSize;
    this.reloadDealerships(this.dealerRequestModel);
  }
  reloadDealerships(dealerRequestModel: UserRequestModel) {
    this.dealershipTableLoadingComplete = false;
    this._dealershipService.getAllDealershipsAdmin(dealerRequestModel).subscribe(response => {
      this.dealershipTableData = response;
      this.dealerRecordCount = response[0].DealerRecordCount
      this.dealershipTableLoadingComplete = true;
      this.loading = false;

    });
  }

  // ///////////////////////////// Dealer ship End////////////////////////////////////////////////
  resetDealerGrouptext() {
    this.filterDealerGroupTableText = "";
    this.reloadDealerGroups();
  }
  reloadDealerGroups() {
    this.dealershipTableLoadingComplete = false;
    this._dealershipService.getAllDealerGroups().subscribe(response => {
      this.dealerGroupTableData = response;
      this.loading = false;
      this.dealershipTableLoadingComplete = true;
    });
  }





  setVisibleComponentsForUser() {
    this.addDealershipVisible = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Administrator', true);
    this.addJobsiteVisible = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.CustomerAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Administrator', true) ||

      this.checkAccess(UserAccessType.GlobalAdministrator, 'Customer Admin', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Customer Admin', true) ||
      this.checkAccess(UserAccessType.CustomerAdministrator, 'Customer Admin', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Customer Admin', true) ||

      this.checkAccess(UserAccessType.GlobalAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.CustomerAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.CustomerUser, 'Undercarriage ONLY', true);

    this.addCustomerVisible = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Administrator', true) ||

      this.checkAccess(UserAccessType.GlobalAdministrator, 'Customer Admin', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Customer Admin', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Customer Admin', true) ||

      this.checkAccess(UserAccessType.GlobalAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.CustomerAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.CustomerUser, 'Undercarriage ONLY', true);

    this.addUserVisible = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Administrator', true) ||
      this.checkAccess(UserAccessType.CustomerAdministrator, 'Administrator', true) ||
      this.checkAccess(UserAccessType.CustomerUser, 'Administrator', true) ||

      this.checkAccess(UserAccessType.GlobalAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.DealershipUser, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.CustomerAdministrator, 'Undercarriage ONLY', true) ||
      this.checkAccess(UserAccessType.CustomerUser, 'Undercarriage ONLY', true);

    this.dealershipsTabVisible = this.checkAccess(UserAccessType.GlobalAdministrator, '', false) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, '', false) ||
      this.checkAccess(UserAccessType.DealershipUser, '', false);
    this.customersTabVisible = this.checkAccess(UserAccessType.GlobalAdministrator, '', false) ||
      this.checkAccess(UserAccessType.DealershipAdministrator, '', false) ||
      this.checkAccess(UserAccessType.DealershipUser, '', false);
    this.addDealerGroupVisible = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true);
  }

  checkAccess(accessCategory: UserAccessType, JobRole: string, JobRoleCheck: boolean): boolean {
    //console.log("this._currentUserJobRoles", this._currentUserJobRoles, this.userAccessType)
    if (JobRoleCheck && !this._currentUserJobRoles.find(m => m === JobRole)) {
      //console.log("JobRoleCheck",JobRole,accessCategory)
      return false;
    }
    if (this.userAccessType === accessCategory) {
      //console.log("Else JobRoleCheck",JobRole,accessCategory)
      return true;
    }
    return false;
  }

  checkRole(role: string): boolean {
    return this._currentUserJobRoles.includes(role.toString());
  }

  checkSuperUserAccess(): boolean {
    return this.checkRole("Super User");
  }

  openAddUserModal(): void {
    const dialogRef = this.dialog.open(AddUserModalComponent, {
      width: '50%',
      height: '95%',
      //panelClass: 'removeModalOverflow'
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadUsers(this.userRequestModel);
      }
    });
  }

  openEditDealershipBrandingModal(styleId: number) {
    const dialogRef = this.dialog.open(EditDealershipBrandingModalComponent, {
      width: '1000px',
      height: '700px',
      //panelClass: 'removeModalOverflow',
      data: {
        styleId: styleId
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadDealerships(this.jobsiteRequestModel);
      }
    });
  }

  openEditUserModal(userId: number): void {
    const dialogRef = this.dialog.open(EditUserModalComponent, {
      width: '50%',
      height: '95%',
      // panelClass: 'removeModalOverflow',
      data: {
        userId: userId
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadUsers(this.userRequestModel);
      }
    });
  }

  disableUser(userId: number) {
    this._userService.disableUser(userId).subscribe(response => {
      if (response.m_Item1) {
        this._notification.success('User Disabled', 'This user has been disabled. ');
        this.reloadUsers(this.userRequestModel);
      } else {
        this._notification.error('Failed to disable user. ', response.m_Item2);
      }
    });
  }

  enableUser(userId: number) {
    this._userService.enableUser(userId).subscribe(response => {
      if (response.m_Item1) {
        this._notification.success('User Enabled', 'This user has been enabled. ');
        this.reloadUsers(this.userRequestModel);
      } else {
        this._notification.error('Failed to enable user. ', response.m_Item2);
      }
    });
  }

  cancelInvitation(invitationId: number) {
    this._userService.cancelInvitation(invitationId).subscribe(response => {
      if (response.m_Item1) {
        this._notification.success('Canceled', 'The users invitation has been canceled. You will need to re-invite them if you want them to use the system. ');
        this.reloadUsers(this.userRequestModel);
      } else {
        this._notification.error('Failed to Cancel', response.m_Item2);
      }
    });
  }

  openAddCustomerModal(): void {
    const dialogRef = this.dialog.open(AddCustomerModalComponent, {
      width: '700px',
      height: '850px'
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadCustomers(this.customerRequestModel);
      }
    });
  }

  openAddJobsiteModal(): void {
    const dialogRef = this.dialog.open(AddJobsiteModalComponent, {
      width: '700px',
      height: '817px'
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadJobsites(this.customerRequestModel);
      }
    });
  }
  openAddDealershipModal(): void {
    const dialogRef = this.dialog.open(AddDealershipModalComponent, {
      width: '700px',
      height: '700px',
      //panelClass: 'removeModalOverflow'
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadDealerships(this.jobsiteRequestModel);
      }
    });
  }

  openAddDealerGroupModal(): void {
    const dialogRef = this.dialog.open(AddDealergroupModalComponent, {
      width: '700px',
      height: '700px',
      //panelClass: 'removeModalOverflow'
      data: {
        newDG: true,
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadDealerGroups();
      }
    });
  }

  openAddBrandedStyleModal(dealershipId: number, dealershipName: string) {
    const dialogRef = this.dialog.open(AddDealershipBrandingModalComponent, {
      width: '1000px',
      panelClass: 'removeModalOverflow',
      data: {
        dealershipId: dealershipId,
        dealershipName: dealershipName
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadDealerships(this.jobsiteRequestModel);
      }
    });
  }

  openEditCustomerModal(customerId: number): void {
    const dialogRef = this.dialog.open(EditCustomerModalComponent, {
      width: '700px',
      height: '850px',
      // panelClass: 'removeModalOverflow',
      data: {
        customerId: customerId
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadCustomers(this.customerRequestModel);
      }
    });
  }

  openEditJobsiteModal(jobsiteId: number): void {
    const dialogRef = this.dialog.open(EditJobsiteModalComponent, {
      width: '700px',
      height: '850px',
      //panelClass: 'removeModalOverflow',
      data: {
        jobsiteId: jobsiteId
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadJobsites(this.customerRequestModel);
      }
    });
  }
  openEditDealershipModal(dealershipId: number): void {
    const dialogRef = this.dialog.open(EditDealershipModalComponent, {
      width: '700px',
      height: '700px',
      //panelClass: 'removeModalOverflow',
      data: {
        dealershipId: dealershipId
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadDealerships(this.jobsiteRequestModel);
      }
    });
  }

  openEditDealerGroup(dealergroupId: number): void {
    const dialogRef = this.dialog.open(AddDealergroupModalComponent, {
      width: '700px',
      height: '700px',
      //panelClass: 'removeModalOverflow',
      data: {
        dealergroupId: dealergroupId,
        newDG: false,
      }
    });
    dialogRef.afterClosed().subscribe(doUpdate => {
      if (doUpdate) {
        this.reloadDealerGroups();
      }
    });
  }

  OpenAssignmentModal(_assignmentType: AssignmentType, _id: number): void {
    const dialogRef = this.dialog.open(AssignModalComponent, {
      width: '700px',
      panelClass: 'removeModalOverflow',
      data: {
        Id: _id,
        Type: _assignmentType,
        AssignmentId: 0
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (_assignmentType <= 6) {
        this.reloadUsers(this.userRequestModel);
      } else if (_assignmentType === AssignmentType.DealerCustomer || _assignmentType === AssignmentType.DealerGroupCustomer) {
        this.reloadCustomers(this.customerRequestModel);
      } else if (_assignmentType === AssignmentType.DealerJobsite) {
        this.reloadJobsites(this.customerRequestModel);
      } else if (_assignmentType === AssignmentType.JobsiteDealer || _assignmentType === AssignmentType.CustomerDealer || _assignmentType === AssignmentType.DealerGroupDealer) {
        this.reloadDealerships(this.jobsiteRequestModel);
      }
    });
  }


  openCustomerNote(customerId) {
    window.open(this.undercarriageUrl + 'customer-notes/' + customerId, '_blank');
  }
  resetPassword(userName: string, email: string) {
    const ref = this.dialog.open(ResetPasswordDialogComponent, {
      width: '400px',
      disableClose: true,
      data: { UserName: userName, Email: email }
    });

    ref.afterClosed().subscribe(password => {
      if (!password) return;
      //console.log('Reset password for user:', userName);
    });
  }

  checkMenuAccess() {
    this._userService.hasMenuAccess("Reset Password").subscribe(response => {
        this.hasMenuAccess = response;
        console.log("checkMenuAccess", this.hasMenuAccess);
    });
  }



}
